/**
 * Who is looking at a widget: the agency building it, or the client reading
 * it in their portal. Notes such as "attach an account" are instructions for
 * the agency and must never reach a client.
 */

import { createContext, useContext } from 'react';

export type Audience = 'agency' | 'client';

export const AudienceContext = createContext<Audience>('agency');

export const useAudience = (): Audience => useContext(AudienceContext);
